import type { WordCollection } from "./collection.types";
import { isCollectionAvailable } from "./logic";

// A collection is seasonal when it has a date window.
export const isSeasonalCollection = (collection: WordCollection): boolean =>
  Boolean(collection.startDate && collection.endDate);

// Complete = every word in the collection has been collected.
export const isCollectionComplete = (
  collection: WordCollection,
  collectedWords: readonly string[],
): boolean => {
  if (collection.words.length === 0) return false;
  const collected = new Set(collectedWords);
  return collection.words.every((word) => collected.has(word));
};

/**
 * The words a game's path collects, per collection id. A word is collected
 * when the player moves to it (the given start word does not count), and
 * only while its collection is available on `date`.
 */
export const collectWordsFromPath = (
  collections: readonly WordCollection[],
  playerPath: readonly string[],
  date: Date,
): Record<string, string[]> => {
  const visited = new Set(playerPath.slice(1));
  const result: Record<string, string[]> = {};
  for (const collection of collections) {
    if (!isCollectionAvailable(collection, date)) continue;
    const words = collection.words.filter((word) => visited.has(word));
    if (words.length > 0) result[collection.id] = words;
  }
  return result;
};
